import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { IconComponent, Maybe, OptionalAsyncPipe } from '@evc/web-components';

import { SearchService } from '../../search/search.service';

@Component({
  selector: 'evc-logo',
  imports: [
    IconComponent,
    OptionalAsyncPipe,
  ],
  templateUrl: './logo.html',
  styleUrl: './logo.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  readonly title = input<string | Observable<string>>();
  readonly logo = input<string>();
  readonly onTitleClick = input<Maybe<() => void>>();

  readonly #router = inject(Router, { optional: true });
  readonly #searchService = inject(SearchService, { optional: true });

  protected readonly customLogoRef = viewChild.required<ElementRef>('customLogo');
  hasCustomLogo = computed(() => {
    const { nativeElement } = this.customLogoRef() ?? {};

    return nativeElement?.children.length > 0;
  });

  onClick(): void {
    const titleClickHandler = this.onTitleClick();

    if (titleClickHandler) {
      titleClickHandler();
    } else {
      this.#router?.navigateByUrl('');
    }
    this.#searchService?.clearSearch();
  }
}
